import { z } from 'zod';

const BaseNodeSchema = z.object({
  type: z.string(),
});
export const VariableNodeSchema = BaseNodeSchema.extend({
  type: z.literal('variable'),
  columnId: z.string(),
  decorations: z
    .object({
      bold: z.boolean().optional(),
      italic: z.boolean().optional(),
      strikethrough: z.boolean().optional(),
      underline: z.boolean().optional(),
      highlight: z.string().optional(),
      color: z.string().optional(),
    })
    .optional(),
});
export const LookupNodeSchema = BaseNodeSchema.extend({
  type: z.literal('lookup'),
  linkColumnId: z.string(),
  refLookupColumnId: z.string(),
  decorations: z
    .object({
      bold: z.boolean().optional(),
      italic: z.boolean().optional(),
      strikethrough: z.boolean().optional(),
      underline: z.boolean().optional(),
      highlight: z.string().optional(),
      color: z.string().optional(),
    })
    .optional(),
});
export const TextNodeSchema = BaseNodeSchema.extend({
  type: z.literal('text'),
  content: z.string(),
  decorations: z
    .object({
      bold: z.boolean().optional(),
      italic: z.boolean().optional(),
      strikethrough: z.boolean().optional(),
      underline: z.boolean().optional(),
      highlight: z.string().optional(),
      color: z.string().optional(),
    })
    .describe('The decorations to include with RichText. Must be present, but can be an empty object.'),
});
export const LinkNodeSchema = BaseNodeSchema.extend({
  type: z.literal('link'),
  url: z.string(),
});
export const ParagraphNodeSchema = BaseNodeSchema.extend({
  type: z.literal('paragraph'),
});
export const LinebreakNodeSchema = BaseNodeSchema.extend({
  type: z.literal('linebreak'),
});
export const ListNodeSchema = BaseNodeSchema.extend({
  type: z.literal('list'),
  listType: z.enum(['ordered', 'unordered']),
});
export const ListItemNodeSchema = BaseNodeSchema.extend({
  type: z.literal('listitem'),
});
export const TabNodeSchema = BaseNodeSchema.extend({
  type: z.literal('tab'),
});

export function WithChildren<
  T extends z.ZodObject<{ type: z.ZodLiteral<string> } & Record<string, z.ZodTypeAny>>,
  ChildType extends object,
>(schema: T, childSchemaFactory: () => z.ZodType<ChildType>) {
  return schema.extend({
    children: z.lazy(() => childSchemaFactory().array()),
  }) as z.ZodObject<T['shape'] & { children: z.ZodLazy<z.ZodArray<z.ZodType<ChildType>>> }>;
}
